import React from 'react';
import { bool } from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import Slider from '@fiverr-private/slider/src';
import SafeComponent from '../shared/SafeComponent';
import { CLICKED_SUBCATEGORY_ARROW } from '../../utils/biEvents/events/mixPanelEvents';
import SubCategory from './SubCategory';
import { subCategories } from './config';

const SubcategoryCarousel = ({ isTouch = false }) => {
    const enrichedSubcategories = subCategories.map((subCategory) => ({...subCategory, isTouch}));

    return (
        <div className="subcategory-carousel lohp-row">
            <h2><I18n k="logged_out_homepage.subcategory_carousel.title"/></h2>
            <Slider freeScroll={isTouch}
                mixPanelEvent={CLICKED_SUBCATEGORY_ARROW}
                items={enrichedSubcategories}
                Component={SubCategory}/>
        </div>
    );
};

SubcategoryCarousel.propTypes = {
    isTouch: bool
};

export { SubcategoryCarousel };
export default SafeComponent(SubcategoryCarousel);
